(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  // Drag-to-scroll functionality for review carousel
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[data-draggable-carousel]');
    
    carousels.forEach(carousel => {
      let isDown = false;
      let startX;
      let scrollLeft;
      
      carousel.addEventListener('mousedown', (e) => {
        isDown = true;
        carousel.classList.add('is-dragging');
        startX = e.pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
      });
      
      carousel.addEventListener('mouseleave', () => {
        isDown = false;
        carousel.classList.remove('is-dragging');
      });
      
      carousel.addEventListener('mouseup', () => {
        isDown = false;
        carousel.classList.remove('is-dragging');
      });
      
      carousel.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - carousel.offsetLeft;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeft - walk;
      });

      // Prevent click on links when dragging
      carousel.addEventListener('click', (e) => {
        if (carousel.classList.contains('is-dragging')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Smooth scroll for shop products button
  document.addEventListener('DOMContentLoaded', () => {
    const shopButtonWrapper = document.querySelector('.shop-products-button-wrapper');
    const shopButton = document.querySelector('.shop-products-button');
    if (shopButtonWrapper && shopButton) {
      const breadcrumbs = document.querySelector('.breadcrumbs-wrapper');
      const productGrid = document.getElementById('ProductGrid');
      let hasClicked = false;
      let lastScrollY = window.scrollY;
      
      // Check if we're in Shopify theme editor
      const isThemeEditor = window.Shopify && window.Shopify.designMode;
      
      // If in theme editor, show button immediately for preview and keep it visible
      if (isThemeEditor) {
        shopButtonWrapper.style.opacity = '1';
        shopButtonWrapper.style.pointerEvents = 'auto';
        
        // Listen for section:load event when settings change in theme editor
        document.addEventListener('shopify:section:load', () => {
          setTimeout(() => {
            const wrapper = document.querySelector('.shop-products-button-wrapper');
            if (wrapper) {
              wrapper.style.opacity = '1';
              wrapper.style.pointerEvents = 'auto';
            }
          }, 100);
        });
        
        // Also listen for any settings changes
        const observer = new MutationObserver(() => {
          if (shopButtonWrapper.style.opacity !== '1') {
            shopButtonWrapper.style.opacity = '1';
            shopButtonWrapper.style.pointerEvents = 'auto';
          }
        });
        
        observer.observe(shopButtonWrapper, {
          attributes: true,
          attributeFilter: ['style']
        });
        
        // Don't run scroll logic in theme editor
        return;
      }
      
      // Show/hide button based on scroll position (only on live site)
      const toggleButtonVisibility = () => {
        if (!breadcrumbs) return;
        
        const currentScrollY = window.scrollY;
        const scrollingUp = currentScrollY < lastScrollY;
        lastScrollY = currentScrollY;
        
        const breadcrumbsRect = breadcrumbs.getBoundingClientRect();
        const productGridRect = productGrid ? productGrid.getBoundingClientRect() : null;
        
        // Reset hasClicked if we scroll back up to breadcrumbs area
        if (breadcrumbsRect.top > -100 && breadcrumbsRect.top < window.innerHeight) {
          hasClicked = false;
        }
        
        // Don't show if already clicked and still in products area
        if (hasClicked) {
          shopButtonWrapper.style.opacity = '0';
          shopButtonWrapper.style.pointerEvents = 'none';
          return;
        }
        
        // Hide if product grid/filter area is in view (reached the products)
        if (productGridRect && productGridRect.top <= 100) {
          shopButtonWrapper.style.opacity = '0';
          shopButtonWrapper.style.pointerEvents = 'none';
          return;
        }
        
        // Show button when breadcrumbs are in or below viewport
        if (breadcrumbsRect.bottom > 0 && breadcrumbsRect.top <= window.innerHeight) {
          shopButtonWrapper.style.opacity = '1';
          shopButtonWrapper.style.pointerEvents = 'auto';
        } else {
          shopButtonWrapper.style.opacity = '0';
          shopButtonWrapper.style.pointerEvents = 'none';
        }
      };
      
      window.addEventListener('scroll', toggleButtonVisibility);
      toggleButtonVisibility(); // Check initial state
      
      // Smooth scroll and hide on click
      shopButton.addEventListener('click', (e) => {
        e.preventDefault();
        hasClicked = true;
        shopButtonWrapper.style.opacity = '0';
        shopButtonWrapper.style.pointerEvents = 'none';
        
        const target = document.getElementById('ProductGrid');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
